import { validateEmail50, validateSomething } from "../../Form/Validations";
import { toast } from "react-toastify";
import RestAPI from "@aws-amplify/api-rest";

export class Weenat {
    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data, i18n) {
        const getPlotSensorsInfo = async (token, plotId, farmId) => {
            const endpoint = `/external/${farmId}/weenat-sensors`;
            const body = { token, plotId, locale: i18n.language };
            const data = await RestAPI.post("apiAdminDropControl", endpoint, { body });
            return data;
        };
        return {
            visible: true,
            activeStep: 0,
            data: {},
            nombre_servicio: data.nombre_servicio,
            resolveBody: (values, props) => {
                const selectedPlot = props.dialogState.data.plots.find(p => p.id === values.plotId);
                const body = {
                    tipo: "WEENAT",
                    token: props.dialogState.data.token,
                    plotId: values.plotId,
                    sectorName: selectedPlot?.name,
                    nodeName: selectedPlot?.name,
                    locale: i18n.language,
                };
                return { url: `/external/${props.farmId}`, body };
            },
            steps: [
                {
                    label: t("external.login"),
                    validateFunction: this.validateLogin,
                    inputs: [
                        {
                            label: t("personal.email"),
                            campo: "email",
                            validation: validateSomething,
                            component: "text",
                        },
                        {
                            useCampo2: true,
                            label: t("external.password"),
                            campo: "password",
                            validation: validateSomething,
                            eyeForPassword: true,
                            component: "text",
                            type: "password"
                        },
                    ],
                },
                {
                    label: t("external.conectar"),
                    inputs: [
                        {
                            label: t("external.organization"),
                            campo: "organization",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "organizations",
                            optionLabel: "name",
                            optionKey: "id",
                            onChange: (value, props) => {
                                const plots = props.dialogState.data.plots;
                                const selectedOrgId = value;
                                let plotsFromOrg;
                                if (selectedOrgId && plots) plotsFromOrg = plots.filter(p => p.organization.id === selectedOrgId);
                                props.setDialogState(prev => ({
                                    ...prev,
                                    data: {
                                        ...prev.data,
                                        plotsFromOrg: plotsFromOrg ?? [],
                                        selectedPlot: null,
                                        plotSensors: null
                                    }
                                }));
                            },
                        },
                        {
                            label: t("external.plot"),
                            campo: "plotId",
                            validation: validateSomething,
                            component: "select",
                            optionsName: "plotsFromOrg",
                            optionLabel: "name",
                            optionKey: "id",
                            triggeredBy: "organization",
                            onChange: async (value, props) => {
                                try {
                                    props.setForceLoading(true);
                                    const selectedPlot = props.dialogState.data.plotsFromOrg && props.dialogState.data.plotsFromOrg.find(plot => value === plot.id);
                                    const plotSensors = await getPlotSensorsInfo(props.dialogState.data.token, selectedPlot.id, props.farmId);
                                    props.setDialogState((state) => ({ ...state, data: { ...state.data, plotSensors, selectedPlot } }));
                                    props.setForceLoading(false);
                                } catch (error) {
                                    props.setDialogState({ visible: false });
                                    props.setForceLoading(false);
                                }
                            }
                        },
                        {
                            component: "info",
                            content: (dialogState) => {
                                return (<>
                                    {
                                        dialogState.data.selectedPlot && dialogState.data.plotSensors &&
                        <>
                            <div className="row linea-formulario" />
                            <div className='col-12 col-md-12'>
                                <label className="boldie text-left">
                                    {t("external.availableSensors")}
                                </label>
                            </div>
                            <div className='mb-2 col-12 col-md-12 d-block'>
                                <ul>
                                    {!dialogState.data.plotSensors.length && <li>No sensors</li>}
                                    {
                                        dialogState.data.plotSensors.map((sensor, id) => {
                                            let text = sensor.tipo;
                                            if (sensor.depths?.length > 0){
                                                const depthsText = sensor.depths.join(", ");
                                                text+= ` (${depthsText})`;
                                            }
                                            return <li key={id}> { text } </li>;
                                        })
                                    }
                                </ul>

                            </div>
                        </>
                                    }
                                </>);
                            }
                        }
                    ]
                },
            ],
        };
    }

    static async validateLogin(values, props) {
        const isSubmitting = props.innerRef.current.isSubmitting;
        const errors = {};
        try {
            if (values) {
                const erUser = validateEmail50(values.email);
                if (erUser !== undefined) errors.email = erUser;

                const erPass = validateSomething(values.password);
                if (erPass !== undefined) errors.password = erPass;

                if(errors.password || errors.email) return errors;

                if (isSubmitting){
                    props.setForceLoading(true);
                    const endpoint = `/external/${props.farmId}/weenat-credentials`;
                    const body = { email: values.email, password: values.password };
                    const resWeenatData = await RestAPI.post("apiAdminDropControl", endpoint, { body });
                    const weenatData = resWeenatData.data;

                    // set data that it will be used in the next step of the form
                    props.setDialogState(s => ({
                        ...s,
                        data: {
                            token: weenatData.token,
                            plots: weenatData.plots,
                            organizations: weenatData.organizations,
                        }
                    }));

                    props.setForceLoading(false);
                }
                return errors;
            }
        } catch (error) {
            if (error.response?.status === 401){
                toast.error(props.t("forms.toast401"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("forms.toast401");
            } else {
                toast.error(props.t("external.error-sign-in"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                errors.unknown = props.t("external.error-sign-in");
            }
            props.setForceLoading(false);
            return errors;
        }
    }
}
